// extracted by mini-css-extract-plugin
module.exports = {"form-select":"Select_form-select__7sTjd"};